// extracted by mini-css-extract-plugin
module.exports = {"flexHeader":"style_flexHeader__1_Z8W","suspendTaskDone":"style_suspendTaskDone__Dk5aC"};